import React from 'react';

import Link from 'next/link';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { withEventScope } from '@repo/event-processor';
import { Spacer } from '@repo/ui/components/Spacer';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import SectionTitleAndText from 'components/Landing/SectionTitleAndText/SectionTitleAndText';
import { getUrlFromLink } from 'prismicio';
import { HideDesktop, HideMobile } from 'styles/queries';

import { List, StyledLink } from './styles';

const LinkListSection: React.FC<
  SliceComponentProps<Content.LinkListSectionSlice>
> = ({ slice }) => {
  return (
    <ContentWrapper
      background="white"
      className="link-list-section"
      customWidth="1345px"
    >
      <SectionTitleAndText slice={slice} />
      <HideDesktop>
        <Spacer height="24px" />
      </HideDesktop>
      <HideMobile>
        <Spacer height="32px" />
      </HideMobile>
      <List>
        {slice.items
          .filter((item) => !!item.label)
          .map(({ label, link }) => (
            <Link
              key={label}
              legacyBehavior
              passHref
              href={getUrlFromLink(link) ?? ''}
            >
              <StyledLink>{label}</StyledLink>
            </Link>
          ))}
      </List>
    </ContentWrapper>
  );
};

export default withEventScope(LinkListSection, { feature: 'linkListSection' });
